import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  locationDiv: {
    maxWidth: "150px",
  },
}));

export default styles;
